<template>
    <input type="text" ref="input" :id="id" class="form-control new-design address-icon auto" :value="value"
           :required="required"
           :placeholder="placeholder"
           @input="handleInput"
           @change="handleInput">
</template>

<script>
export default {
    name: "AddressInput",
    props: ['value', 'placeholder', 'required', 'countryCode'],
    computed:{
      id(){
        let min = 2167381;
        let max = 9999999;
        let rand = Math.floor(Math.random() * (max - min + 1) ) + min
        return `map_${rand}`;
      }
    },
    methods: {
        handleInput(event) {
            this.$emit('input', event.target.value)
        },
        initialize() {
          // let vm = this ;
          //   autocomplete = new window.google.maps.places.Autocomplete(this.$refs['input'], {types: ['geocode']});
          //   autocomplete.setComponentRestrictions({'country': [this.countryCode]});
          //
          //   autocomplete.addListener('place_changed', function () {
          //     vm.$emit('input', autocomplete.getPlace().formatted_address ?? vm.value);
          //     if (autocomplete.getPlace()){
          //       window.show_Map_Admin(vm.id,0,1,autocomplete.getPlace());
          //     }
          //   });
        }
    },
    mounted() {
        this.initialize();
    }
}
</script>

<style scoped>
.form-control.new-design::placeholder {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.form-control.new-design {
    padding: 16px;
    border: 1px solid #E0E2E5;
    border-radius: 8px;
    box-sizing: border-box;

    height: 56px;

    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.address-icon {
    background-repeat: no-repeat;
    background-position: 15px 17px;
    padding-left: 45px !important;
    background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.5 0L17.34 0.03L12 2.1L6 0L0.36 1.9C0.15 1.97 0 2.15 0 2.38V17.5C0 17.78 0.22 18 0.5 18L0.66 17.97L6 15.9L12 18L17.64 16.1C17.85 16.03 18 15.85 18 15.62V0.5C18 0.22 17.78 0 17.5 0ZM7 2.47L11 3.87V15.53L7 14.13V2.47ZM2 3.46L5 2.45V14.15L2 15.31V3.46ZM16 14.54L13 15.55V3.86L16 2.7V14.54Z' fill='%232E4051'/%3E%3C/svg%3E");
}
</style>